<template>
	<div class="placed-backg contact-page-" id="page-info-t1">
		<div class="bg-image" v-bind:style="{ backgroundImage: 'url(public/images/pages/contact/bg.jpg)' }"></div>

		<section class="container oversized-container content-section">
			<div class="row align-items-center justify-content-center">
				<div class="col-lg-5 text-center col-info">
					<h1 class="mb-2 page-title">Contacto empresarial</h1>

					<p class="mt-2">
						Escríbenos o llámanos para contactarnos.
					</p>

					<hr />

					<h5 class="subtitle-sm">Dirección:</h5>

					<p>
						Av Chapultepec #1305a Pent House<br />
						Privadas del Pedregal <br />
						San Luis Potosi SLP, CP 78295<br />
						Ref: Edificio Open Corporativo<br />
					</p>

					<h5 class="subtitle-sm">Correo Electrónico:</h5>

					<p>
						<a href="mailto:ventas@blackfon.mx">ventas@blackfon.mx</a>
					</p>

					<h5 class="subtitle-sm">Teléfonos:</h5>

					<ul>
						<li><a href="tel:+52 800 611 0033">800 611 0033</a></li>
						<li><a href="tel:*611">*611 (Desde tu BlackFon)</a></li>
					</ul>

				</div>

				<div id="form-holder" v-if="!isSent" key="form" class="col-lg-5 col-xl-4 col-info">
					<b-form @submit="onSubmit">

						<div class="row">
							<div class="col-md-6">
								<b-form-group class="custom-f-group">
									<b-form-input v-model="form.nombre" type="text" required
										placeholder="Nombre"></b-form-input>
								</b-form-group>
							</div>
							<div class="col-md-6">
								<b-form-group class="custom-f-group">
									<b-form-input v-model="form.telefono" type="text" required
										placeholder="Teléfono"></b-form-input>
								</b-form-group>
							</div>
						</div>

						<div class="row">
							<div class="col-md-7">
								<b-form-group class="custom-f-group">
									<b-form-select v-model="form.estado" :options="estados" required
										placeholder="Selecciona un estado"></b-form-select>
								</b-form-group>
							</div>
							<div class="col-md-5">
								<b-form-group class="custom-f-group">
									<b-form-input v-model="form.zip_code" type="number" minlength="5" maxlength="6"
										required placeholder="Código postal"></b-form-input>
								</b-form-group>
							</div>
						</div>

						<b-form-group class="custom-f-group">
							<b-form-textarea v-model="form.mensaje" required placeholder="Mensaje"></b-form-textarea>
						</b-form-group>

						<p class="text-center">
							<b-button type="submit" class="btn-send btn-s2" :disabled="isProcessing">
								<span v-if="isProcessing">Enviando...</span>
								<span v-else>Enviar</span>
							</b-button>
						</p>
					</b-form>
				</div>
				<div id="form-sent" v-else key="isSent" class="col-lg-5 col-xl-4 col-info">
					<ui-dotlottie-loader />
					<b-jumbotron class="text-center">
						<p>{{ messageSent }}</p>
					</b-jumbotron>
					<p class="text-center">
						<b-button class="btn-send btn-s2" @click="isSent = false">Enviar otro</b-button>
					</p>
				</div>
			</div>
		</section>

		<!-- <ui-dotlottie-loader class="hidden" /> Ayuda a precarga el JSON animado -->
		<ui-dotlottie-loader class="hidden" />

	</div>
</template>

<script>
import { notify } from '@/js/utils.js';
import Axios from 'axios';
import _ from 'lodash'

const emptyForm = {
	nombre: null,
	estado: null,
	zip_code: null,
	telefono: null,
	mensaje: null
};

export default {
	props: {
		messageSent: {
			type: String,
			default: 'Tu mensaje ha sido enviado exitosamente'
		},
		estados: {
			type: Array,
			default: () => {
				return [
					"Aguascalientes",
					"Baja California",
					"Baja California Sur",
					"Campeche",
					"Chiapas",
					"Chihuahua",
					"Ciudad de México",
					"Coahuila",
					"Colima",
					"Durango",
					"Guanajuato",
					"Guerrero",
					"Hidalgo",
					"Jalisco",
					"Estado de México",
					"Michoacán",
					"Morelos",
					"Nayarit",
					"Nuevo León",
					"Oaxaca",
					"Puebla",
					"Querétaro",
					"Quintana Roo",
					"San Luis Potosí",
					"Sinaloa",
					"Sonora",
					"Tabasco",
					"Tamaulipas",
					"Tlaxcala",
					"Veracruz",
					"Yucatán",
					"Zacatecas"
				];
			}
		}
	},

	data() {
		return {
			isProcessing: false,
			isSent: false,
			form: _.cloneDeep(emptyForm),
		}
	},

	methods: {
		async onSubmit(evt) {
			evt.preventDefault();
			this.isProcessing = true;
			try {
				const response = await Axios.post('contacto/alta', this.form);
				if (response.status) {
					this.form = _.cloneDeep(emptyForm)
					this.isSent = true;
					// notify('Mensaje enviado con éxito');
				} else if (response.msg) {
					notify(response.msg);
				} else {
					notify('Error al enviar el mensaje');
				}
			} catch (e) {
				notify(e)
			} finally {
				this.isProcessing = false;
			}
		}
	}
}
</script>

<style scoped>
.hidden {
	display: none;
}
</style>

<style lang="scss">
.subtitle-sm {
	margin-top: 1em;
	margin-bottom: 1em;
}
</style>